<template>
  <div class="content" style="margin-bottom: 0">
    <div class="box-iframe" v-if="url">
      <iframe id="myIframe" :src="url" frameborder="0"></iframe>
    </div>
  </div>
</template>
<script>
  import TopBar from "../../components/commons/TopBar";
  import Loading from "../../components/gestor/loading";

  export default {
    components: {Loading, TopBar},
    props: ['src', 'auth'],
    data() {
      return {
        url: null,
        loading: true,
        allowedOrigin: null
      }
    },

    methods: {
      async onMessage(event) {
        if (event.origin !== this.allowedOrigin) {
          console.warn("Origem inválida:", event.origin);
          return;
        }

        const msg = event.data;

        if (!msg?.type) return;

        if (msg.type === "open-file") {
          this.$helpers.openArquivo(this, msg.url, msg.tipo);
        }
      }
    },

    mounted() {
      if (this.src) {
        this.url = this.src + (this.auth ? `?auth=${this.auth}` : '');
        this.allowedOrigin = new URL(this.src).origin;
      }

      window.addEventListener("message", this.onMessage);
    },

    beforeDestroy() {
      window.removeEventListener("message", this.onMessage);
    }
  }
</script>
<style>
</style>
